import { KnmTypeIdsByCodeEnum } from 'APIPackage/CatalogsModule/enums/KnmTypeIdsByCodeEnum';
import { IKnmIndex } from 'APIPackage/KnmModule/interfaces/IKnmIndex';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import {
  DATE_FORMAT_FULL_FNS,
  DATE_FORMAT_LONG_FNS,
  DATE_FORMAT_SYSTEM_FULL_FNS,
} from 'CorePackage/MainModule/constants/dateFormats';
import { getNewMappedStatus } from 'KnmErpPackage/MainModule/common/getNewMappedStatus';

import { IKnmRaw } from '../interfaces/IKnmRaw';

const renderKnmType = (knmType: string, isErknm: boolean) => {
  if (isErknm && knmType === 'Плановая проверка') {
    return 'Плановое КНМ';
  }

  if (isErknm && knmType === 'Внеплановая проверка') {
    return 'Внеплановое КНМ';
  }

  return knmType;
};

const getRegistryText = (value?: boolean) => {
  let res = '-';

  if (value === true) {
    res = 'Да';
  } else if (value === false) {
    res = 'Нет';
  }

  return res;
};

const getCorrectTextDate = (date?: string, typeId?: KnmTypeIdsByCodeEnum) => {
  if (date) {
    return formatDate({ date, dateFormat: DATE_FORMAT_FULL_FNS, parseFormat: DATE_FORMAT_SYSTEM_FULL_FNS });
  }

  if (typeId === KnmTypeIdsByCodeEnum.VP) {
    return ' ';
  }

  return 'Не указано';
};

export const mapDataItemToRaw = (row: IKnmIndex, isErknm: boolean) => ({
  ...row,
  startDateEn: `${
    row.startDate ? formatDate({ date: row.startDate, dateFormat: DATE_FORMAT_LONG_FNS }) : 'Не указано'
  } - ${row.stopDate ? formatDate({ date: row.stopDate, dateFormat: DATE_FORMAT_LONG_FNS }) : 'Не указано'}`,
  status: isErknm ? row.status : getNewMappedStatus(row.status, row.isImpossibleConductionReasonExist),
  knmType: renderKnmType(row.knmType ?? '', isErknm),
  approvedErknm: row.approvedErknm ? row.approvedErknm : '',
  approved: row.approved ? 'Утверждено' : 'Отклонено',
  lists: `${row.chlistFilledCount}/${row.chlistCount}`,
  torRegistryExists: getRegistryText(row.torRegistryExists),
  spvRegistryExists: getRegistryText(row.spvRegistryExists),
  sezRegistryExists: getRegistryText(row.sezRegistryExists),
  resultEmpty: row.resultEmpty ? 'Нет' : 'Да',
  hasViolations: row.hasViolations ? 'Да' : 'Нет',
  approveDocOrder:
    row.approveDocOrderNum && row.approveDocOrderDate ? `${row.approveDocOrderNum} от ${row.approveDocOrderDate}` : '',
  createPlanDate: getCorrectTextDate(row.createPlanDate, row.knmTypeId),
  updatePlanDate: getCorrectTextDate(row.updatePlanDate, row.knmTypeId),
  inn: row?.inn ? row.inn.split(',').join(', ') : null,
  ogrn: row?.ogrn ? row.ogrn.split(',').join(', ') : null,
});

export const mapRawToData = (data: IKnmIndex[], isErknm: boolean): IKnmRaw[] => {
  return data.map(row => {
    return mapDataItemToRaw(row, isErknm);
  });
};
